import type React from "react";
import { useState, useEffect, useRef } from "react";

const daysOfWeek = ["日", "月", "火", "水", "木", "金", "土"];

const eventDays: { [key: string]: string } = {
	火: "18:00 | 21:00",
	土: "14:00 | 17:00",
};

const EventTime: React.FC = () => {
	const [titleHeight, setTitleHeight] = useState(0);
	const titleRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (titleRef.current) {
			const titleElement = titleRef.current.querySelector("h2");
			if (titleElement) {
				const styles = window.getComputedStyle(titleElement);
				const marginBottom = Number.parseFloat(styles.marginBottom);
				setTitleHeight(titleElement.offsetHeight + marginBottom);
			}
		}
	}, []);

	return (
		<section className="py-16 bg-gray-100">
			<div className="container mx-auto">
				<div ref={titleRef}>
					<h2 className="text-3xl font-bold text-center mb-8">
						毎週開催しています
					</h2>
				</div>
				<div
					className="bg-white rounded-lg shadow-md p-6"
					style={{ minHeight: `calc(100% - ${titleHeight}px)` }}
				>
					<p className="text-center text-lg mb-6">
						火曜日と土曜日の週2回開催なので <br />
						自分のペースで参加できます
					</p>
					<div className="flex justify-between space-x-2 md:space-x-4 border-b-2 border-gray-200 pb-6 mb-6">
						{daysOfWeek.map((day) => (
							<div
								key={day}
								className="flex flex-col items-center justify-end w-full"
							>
								{eventDays[day] ? (
									<div className="bg-blue-500 text-white rounded-lg p-2 md:p-4 w-full h-full flex flex-col items-center justify-center">
										<h3 className="text-lg md:text-2xl font-bold">{day}</h3>
										<p className="text-sm md:text-base">{eventDays[day]}</p>
									</div>
								) : (
									<div className="bg-gray-200 rounded-lg p-2 md:p-4 w-full h-3/4 flex items-center justify-center">
										{day}
									</div>
								)}
							</div>
						))}
					</div>
				</div>
			</div>
		</section>
	);
};

export default EventTime;
